import { render } from "./VariantSelector.vue?vue&type=template&id=bf393540&scoped=true"
import script from "./VariantSelector.js?vue&type=script&lang=js"
export * from "./VariantSelector.js?vue&type=script&lang=js"

import "./VariantSelector.vue?vue&type=style&index=0&id=bf393540&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf393540"]])

export default __exports__